import { Routes, BrowserRouter as Router, Route, useNavigate } from "react-router-dom";
import './App.css';
import Dashboard from "./Components/Pages/Dashboard/Dashboard"
import Lesson from "./Components/Pages/Lesson/Lesson";
import Login from "./Components/Account/Login";
import VerifyEmail from "./Components/Account/VerifyEmail";
import PasswordReset from "./Components/Account/PasswordReset";
import { useAppDispatch, useAppSelector } from "./hooks";
import { useEffect } from "react";
import NotFound from "./Components/Pages/NotFound";
import Tribe from "./Components/Pages/Tribe/Tribe";
import Unit from "./Components/Pages/Unit/Unit";
import { setToken } from "./reducers/UserSplice";
import { getNewAccessToken } from "./api/auth";
import { setActiveTab, setActiveType, setSubMenuActiveTab } from "./reducers/tabSplice";
import SpellingBee from "./Components/Pages/Challenge/SpellingBee";
import Puzzle from "./Components/Pages/Challenge/Puzzle";
import CheckTheRhyme from "./Components/Pages/Challenge/CheckTheRhyme";
import UnitIntro from "./Components/Pages/Unit-Intro/UnitIntro";
import Overlay from "./Overlay";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './store/store';

const PrivateRouteWeb: React.FC<{ element: React.ReactNode }> = ({ element }) => {
  const userData = useAppSelector((state) => state.user.token);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  useEffect(() => {
    const checkAuthentication = async () => {
      const activeTab = localStorage.getItem("activeTab");
      const activeSubMenu = localStorage.getItem("activeSubMenu");
      const activeType = localStorage.getItem("type");

      dispatch(setActiveTab(activeTab ? activeTab : "dashboard"));
      dispatch(setSubMenuActiveTab(activeSubMenu ? activeSubMenu : "check-the-rhyme"));
      dispatch(setActiveType(activeType ? activeType : "0"))
      if (!userData.access_token) {
        if (userData.refresh_token) {
          await getNewAccessToken({ refreshToken: userData.refresh_token }).then((newTokenResponse) => {
            const { data, statusCode } = newTokenResponse;
            if (statusCode === 200) {
              dispatch(setToken({
                access_token: data.accessToken,
                refresh_token: data.refreshToken
              }))
            }
          })
        } else {
          navigate("/")
        }

      }
    };

    checkAuthentication();
  }, [navigate, dispatch, userData]); // Kept 'dispatch' in dependencies to prevent stale closure issues

  return <>{element}</>;
};




function App() {
  return (
    <div>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <Overlay />
            <div>
              <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/verify-email" element={<VerifyEmail />} />
                <Route path="/password-reset/:key/:emailParam" element={<PasswordReset />} />
                <Route path="/dashboard" element={<PrivateRouteWeb element={<Dashboard />} />} />
                <Route path="/lesson" element={<PrivateRouteWeb element={<Lesson />} />} />
                <Route path="/tribe" element={<PrivateRouteWeb element={<Tribe />} />} />
                <Route path="/unit" element={<PrivateRouteWeb element={<Unit />} />} />
                <Route path="/unit/questions" element={<PrivateRouteWeb element={<UnitIntro />} />} />
                <Route path="/check-the-rhyme" element={<PrivateRouteWeb element={<CheckTheRhyme />} />} />
                <Route path="/spelling-bee" element={<PrivateRouteWeb element={<SpellingBee />} />} />
                <Route path="/puzzle" element={<PrivateRouteWeb element={<Puzzle />} />} />

                {/* Fallback Route for Not Found */}
                <Route path="*" element={<NotFound />} />

              </Routes>
            </div>
          </Router>
        </PersistGate>
      </Provider>
    </div>

  );
}

export default App;

